import React from 'react';
import * as R from 'ramda';
import {LaunchDarkly} from 'react-launch-darkly';
import {LDProvider} from 'launchdarkly-react-client-sdk';

const userEmail = R.path(['userInfo', 'email'], window);
const userType = R.path(['userInfo', 'type'], window);

const ldUser = {
    key: userEmail,
    email: userEmail,
    custom: {
        type: userType
    }
};

const FeatureFlagProvider = ({children, launchDarklyClientId}) => (
    <LaunchDarkly clientId={launchDarklyClientId} user={ldUser}>
        <LDProvider clientSideID={launchDarklyClientId} user={ldUser}>
            {children}
        </LDProvider>
    </LaunchDarkly>
);

export default FeatureFlagProvider;



// WEBPACK FOOTER //
// ./components/feature_flag_provider/index.js